<template>
   
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Configuración de la aplicación</p>
        </template>
        <b-row>
            <b-col cols="12" md="4">
                <label>Porcentaje Rentabilidad</label>
                <b-input-group prepend="%">
                    <b-form-input v-model="configuracion.porcentaje" type="number"  placeholder="Porcentaje rentabilidad"></b-form-input>
                </b-input-group>
                <b-badge v-if="configuracion.porcentaje < 0 || configuracion.porcentaje > 99" variant="danger">
                    El porcentaje de rentabilidad debe estar entre 0 y 99
                </b-badge>
            </b-col>
            <b-col cols="12" md="4">
                <label>Color Corporativo</label>
                <b-form-input type="color" v-model="configuracion.color" value="#ffffff"></b-form-input>
            </b-col>
            <b-col cols="12" md="4">
                <label>Logo Corporativo</label>
                <b-form-file
                v-model="logo"
                :state="Boolean(logo)"
                accept="image/*"
                placeholder="Elige un archivo o arrastralo aqui..."
                drop-placeholder="Arrastra un archivo aqui..."
                browse-text="Explorar"
                ></b-form-file>
            </b-col>
        </b-row>
        <b-row class="py-3">
            <b-col cols="12" md="6">
                <b-form-checkbox v-model="configuracion.opcion_existencia" switch>
                    Maneja Existencias
                </b-form-checkbox>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-checkbox v-model="configuracion.show_supplier_price" switch>
                    Mostrar Precio Proveedor en Items 
                </b-form-checkbox>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group  v-slot="{ ariaDescribedby }">
                    Tipo de Entrega para pedidos Proveedor:
                    <b-form-radio v-model="configuracion.tipo_entrega" :aria-describedby="ariaDescribedby" value="1">Entrega a domicilio</b-form-radio>
                    <b-form-radio v-model="configuracion.tipo_entrega" :aria-describedby="ariaDescribedby" value="2">Recojo en punto de venta</b-form-radio>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group  v-slot="{ ariaDescribedby }">
                    Sincronización de Precios:
                    <b-form-radio v-model="configuracion.opcion_precio_propio" :aria-describedby="ariaDescribedby" value="1">Automatica con el porcentaje de rentabilidad definido</b-form-radio>
                    <b-form-radio v-model="configuracion.opcion_precio_propio" :aria-describedby="ariaDescribedby" value="2">Definido por el cliente</b-form-radio>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="8">
                <b-alert show variant="danger">Tenga en cuenta que si el item esta registrado en el módulo de precios personalizados,
                    el precio a mostrar sera el definido en esa área</b-alert>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group  v-slot="{ ariaDescribedby }">
                    Precio Detal Sugerido por el Proveedor (Iva Incluido):
                    <b-form-radio v-model="configuracion.precio_sugerido" :aria-describedby="ariaDescribedby" value="0">No</b-form-radio>
                    <b-form-radio v-model="configuracion.precio_sugerido" :aria-describedby="ariaDescribedby" value="1">Si</b-form-radio>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4" v-if="configuracion.precio_sugerido == 0">
                <b-form-group  v-slot="{ ariaDescribedby }">
                    Rentabilidad por origen:
                    <b-form-radio v-model="configuracion.rentabilidad_origen" :aria-describedby="ariaDescribedby" value="0">No</b-form-radio>
                    <b-form-radio v-model="configuracion.rentabilidad_origen" :aria-describedby="ariaDescribedby" value="1">Si</b-form-radio>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mb-2" v-if="configuracion.rentabilidad_origen == 1 && configuracion.precio_sugerido == 0">
            <b-col cols="12" md="4">
                <label>Porcentaje rentabilidad items nacionales</label>
                <b-input-group prepend="%">
                    <b-form-input v-model="configuracion.porcentaje_nacional" type="number"  placeholder="Porcentaje rentabilidad"></b-form-input>
                </b-input-group>
                <b-badge v-if="configuracion.porcentaje_nacional < 0 || configuracion.porcentaje_nacional > 99" variant="danger">
                    El porcentaje de rentabilidad debe estar entre 0 y 99
                </b-badge>
            </b-col>
            <b-col cols="12" md="4">
                <label>Porcentaje rentabilidad items importados</label>
                <b-input-group prepend="%">
                    <b-form-input v-model="configuracion.porcentaje_importado" type="number"  placeholder="Porcentaje rentabilidad"></b-form-input>
                </b-input-group>
                <b-badge v-if="configuracion.porcentaje_importado < 0 || configuracion.porcentaje_importado > 99" variant="danger">
                    El porcentaje de rentabilidad debe estar entre 0 y 99
                </b-badge>
            </b-col>
        </b-row>
        <b-button variant="info" @click.prevent="setConfigurationMaster(), setLogoMaster()" >
            Actualizar Información
        </b-button>
    </b-card>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
export default {
    data(){
        return{
            configuracion: {
                porcentaje: null,
                color: '',
                menu: false,
                opcion_existencia: false,
                tipo_entrega: '',
                opcion_precio_propio: '',
                precio_sugerido: '',
                show_supplier_price: ''
            },
            logo: null,
            empresaPermissions: [],
            canUseModuleItem: false,
        }    
    },
    created(){
        this.getConfigurationMaster();
    },
    methods: {
        ...mapMutations(['setLoading']),
        ...mapActions('configuration', ['getConfiguration']),
        async getConfigurationMaster(){
            this.setLoading(true);
            this.empresaPermissions = localStorage.getItem('empresa_permissions');
            if(this.empresaPermissions.includes('can_use_module_items_empresa')){
                this.canUseModuleItem = true;
            }
            await this.$conectar.post('configuracion/get-configuration-master')
            .then(response =>{
                this.configuracion = response.data.configuracion;
                
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false);
        },
        async setConfigurationMaster(){
            this.setLoading(true);
            if(this.canUseModuleItem === true){
                if(this.configuracion.opcion_existencia === true){
                    this.configuracion.opcion_existencia = 1;
                }else{
                    this.configuracion.opcion_existencia = 0;
                }
            }
            if(this.configuracion.show_supplier_price === true){
                this.configuracion.show_supplier_price = 1;
            }else{
                this.configuracion.show_supplier_price = 0;
            }
            await this.$conectar.post('configuracion/set-configuration-master', this.configuracion)
            .then(response =>{
                if(response.data.error == false){
                    this.setLoading(false);
                    this.getConfigurationMaster();
                    this.getConfiguration();
                    this.$bvToast.toast('Configuración actualizada correctamente', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    });
                }else{
                    this.$bvToast.toast('Hubo un error al actualizar la configuración', {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Hubo un error al actualizar la configuración', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false);
        },
        async setLogoMaster(){
            if(this.logo !== null){
                let formData = new FormData();
                formData.append('logo', this.logo);
                await this.$conectar.post('configuracion/set-logo-master',
                    formData, {
                        headers: {
                        'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response =>{
                        if(response.data.error == false){
                        this.getConfiguration();
                    }
                    })
                    .catch(e => {
                    console.log(e.response);
                    });
            }
                this.logo = null;
        },
        printcolor(){
            console.log(this.colorr)
        }
    }
}
</script>